// Components==============
import Modal from 'components/UI/Modal';
import RichText from 'components/UI/RichText';
import React from 'react';
import './index.module.scss';
// =========================

export default function CardModal({
    modalIsOpen,
    setModalIsOpen,
    title,
    description,
    image,
    richText,
}) {
    return (
        <Modal
            modalIsOpen={modalIsOpen}
            closeModal={() => setModalIsOpen(false)}
            image={image}
            imageText={title}
        >
            <div styleName="wrapper">
                {description && <p styleName="description">{description}</p>}
                <RichText richText={richText} />
            </div>
        </Modal>
    );
}
